module.exports = __webpack_public_path__ + "img/1-4.103450c9.png";